import PT from "prop-types";
import React from "react";
import { styled } from "styled-components";
import { Provider } from "react-redux";

import { LiveChatButton } from "../live-chat/live-chat-button";

const Container = styled.div`
  position: absolute;
  right: 5px;
  top: 8px;
  & > a > img {
    width: 134px;
    height: 33px;
  }
`;

export const LiveChatRoot = ({ store }) => {
  return (
    <Provider store={store}>
      <Container>
        <LiveChatButton />
      </Container>
    </Provider>
  );
};

LiveChatRoot.propTypes = {
  store: PT.object
};
